import { TLoginData } from "../models/Auth/Auth";
import AlertManager from "./AlertManager";
import { AppStateSyncManager } from "./AppStateSyncManager";
import { AuthManager } from "./AuthManager";
import { OrgManager } from "./OrgManager/OrgManager";
import { IOEventTypes, RealtimeRequestManager } from "./RealtimeManager";
import { RouteManager } from "./RouteManager";
import { UserManager } from "./UserManager/UserManager";
import { APIManager } from "./APIManager";
import { SubscriptionManager } from "./SubscriptionManager/SubscriptionManager";
import { NotificationManager } from "./NotificationManager/NotificationManager";
import { DealerGroupManager } from "./DealerGroupManager/DealerGroupManager";

export class AppManager {
    static auth = new AuthManager({
        postLoginCallback: AppManager.postLoginHook,
        postLogoutCallback: AppManager.postLogoutHook,
    });
    static alert = AlertManager;
    static user = new UserManager();
    static org = new OrgManager();
    static dGroup = new DealerGroupManager();
    static realtime = new RealtimeRequestManager();
    static subscription = new SubscriptionManager();
    static route = RouteManager;
    static sync = AppStateSyncManager;
    static request = APIManager;
    static notifications = NotificationManager;

    static reAuthenticateUser() {
        RouteManager.gotoLogin(RouteManager.CURRENT_ROUTE);
    }

    private static onRealtimeData<K extends keyof IOEventTypes>(evt: K, data: IOEventTypes[K]) {}

    private static postLoginHook(data: TLoginData) {
        AppManager.realtime.init({
            onReAuthenticate: AppManager.reAuthenticateUser,
            onDataReceived: AppStateSyncManager.networkDataReceived,
            onReconnected: AppManager.postConnectionRestoredHook,
        });
    }
    private static postLogoutHook() {
        AppManager.realtime.destroy();
    }

    private static postConnectionRestoredHook() {
        AppStateSyncManager.networkConnectionRestored();
    }
}
